import api from '../../utils/api'

export function getUserProfile() {
  return api.get(`v3/users/profile`)
}

export function updateUserPassword(currentPassword, newPassword) {
  api.post(`v3/users/temporary_password`, {
    current_password: currentPassword,
    new_password: newPassword,
  })
}
